export default function footerRendering() {
    return "\n        <div class=\"footer\">\n            <p class=\"footer-text\">Copyright \u00A9 2021 - Made by Marcos</p>\n            <div class=\"footer-links\">\n                <a href=\"#/\">Informacion Legal</a> |\n                <a href=\"#/\">Arrepentimiento de Compra</a>\n            </div>\n        </div>\n";
}
